import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { apiUrl } from "../config/url";
import Navbar from './Navbar';

const CompanyInfo = () => {
    const company_id = localStorage.getItem("company_id");
    const [companyData, setCompanyData] = useState(null);

    const fetchCompanyInfo = async () => {
        try {
            const token = localStorage.getItem("api_token");
            // console.log("Fetching company info for company_id:", company_id);
            const response = await axios.get(`${apiUrl}/admin/getUserCompanyInformation?company_id=${company_id}`, {
                headers: {
                    api_token: token,
                },
            });

            console.log("API Response:", response.data.data);

            if (response.data) {
                setCompanyData(response.data);
                // console.log("Company data set successfully:", response.data);
            } else {
                console.error("Expected data but got:", response.data);
                toast.error("Failed to fetch company information");
            }
        } catch (error) {
            console.error("Error fetching company info:", error);
            toast.error("Failed to fetch company information");
        }
    };

    useEffect(() => {
        fetchCompanyInfo();
    }, []);

    if (!companyData) {
        // console.log("Company data is not yet available, showing loading...");
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center mt-10">Loading...</div>
            </div>
        );
    }


    return (
        <>
            <Navbar />
            <div className="flex flex-col items-center justify-center min-h-screen p-5">
                <h1 className="text-3xl font-bold mb-6 text-center text-indigo-600">
                    Company Information
                </h1>
                <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full border-l-4 border-indigo-600">
                    <h2 className="text-2xl font-semibold mb-4 text-center text-gray-800">
                        {companyData.data.company_name}
                    </h2>
                    <div className="space-y-2">
                        <p className="text-lg text-gray-800">
                            <span className="font-bold text-indigo-600">Address :</span> {companyData.data.address_1} {companyData.data.address_2}
                        </p>
                        <p className="text-lg text-gray-800">
                            <span className="font-bold text-indigo-600">TIN Number :</span> {companyData.data.tin_number}
                        </p>
                        <p className="text-lg text-gray-800">
                            <span className="font-bold text-indigo-600">Mobile No :</span> {companyData.data.mob_no}
                        </p>
                        <p className="text-lg text-gray-800">
                            <span className="font-bold text-indigo-600">From Date :</span> {companyData.data.from_date}
                        </p>
                        <p className="text-lg text-gray-800">
                            <span className="font-bold text-indigo-600">Till Date :</span> {companyData.data.till_date}
                        </p>
                    </div>
                </div>
            </div>




        </>

    );
};


export default CompanyInfo;
